import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { notMaintenanceGuard } from './core/guards/maintenance.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'partner',
    pathMatch: 'full'
  },
  {
    path: 'partner',
    canMatch: [notMaintenanceGuard, authGuard],
    canActivate: [authGuard, roleGuard],
    loadChildren: () =>
      import('./features/admin/admin.route')
        .then(r => r.ADMIN_ROUTES)
  },
  {
    path: '**',
    canMatch: [notMaintenanceGuard],
    loadComponent: () => import('./features/not-found/not-found').then(m => m.NotFound)
  }
];
